import { AfterViewInit, Component, Input, OnDestroy, OnInit, TemplateRef, ViewChild, inject } from "@angular/core";
import { NZ_MODAL_DATA, NzModalRef, NzModalService } from "ng-zorro-antd/modal";
import { DomSanitizer } from "@angular/platform-browser";
import _ from "lodash";

import { PlatformType, PlatformInfo } from "@root/config";
import { AccountService } from "@root/router/channel/account/account.service";
import { UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { TranslateService } from "@root/shared/service/translate.service";
import { StoreService } from "@root/shared/service/store.service";
import { ModalService } from "@root/router/index/modal.service";
import { interval, Subject } from "rxjs";
import { takeUntil } from "rxjs";

export enum EditMode {
  Create = 1, // 添加账号之后的模式，此时为空表单
  Update = 0, // 重新登录之后的模式，此时表单需要填充用户名
}

interface IModalData {
  thirdpartyType: PlatformType;
  accountId: number;
  username: string;
  editMode?: EditMode;
}

@Component({
  templateUrl: "./account-form-modal.component.html",
  styleUrls: ["./account-form-modal.component.scss"],
})
export class AccountFormModalComponent implements OnInit, AfterViewInit, OnDestroy {
  //#region fliggyLoginIframe
  @ViewChild("fliggyIframe") fliggyIframe: TemplateRef<any>;
  fliggyIframeUrl;
  //#endregion
  readonly Platform: typeof PlatformType = PlatformType;
  readonly EditMode: typeof EditMode = EditMode;
  readonly modalData: IModalData = inject(NZ_MODAL_DATA);
  passwordVisible = false;

  //#region restruct
  // ====================================================
  /**  本组件只保留创建功能，修改密码的功能独立出去  */

  editMode: EditMode = this.modalData.editMode;

  thirdpartyType = this.modalData.thirdpartyType;
  /** @required */
  accountId = this.modalData.accountId;
  /** @required when editMode === Update */
  username = this.modalData.username;
  /** @required when editMode === Update */

  form: UntypedFormGroup = this.fb.group({
    username: ["", Validators.required],
    password: ["", Validators.required],

    verifyCode: "",
    verifyPayload: null, // 途家、携程滑块验证码
  });

  verifyImage;
  /** @required by tujia and muniao */
  verifyKey;
  /** @required by tujia and muniao */
  captchaInfo; // 途家和携程滑块验证码初始化需要的信息

  meituanLoginStatus = null; // null（未安装） | 0（未获取到） | 1（已登录）
  meituanLoginInfo = null;

  get thirdpartyInfo() {
    return PlatformInfo[this.thirdpartyType];
  }

  private destroy$ = new Subject();
  // ====================================================
  //#endregion
  constructor(
    private accountService: AccountService,
    private subject: NzModalRef,
    private sanitizer: DomSanitizer,
    private fb: UntypedFormBuilder,
    private modalService: NzModalService,
    private storeService: StoreService,
    private translate: TranslateService,
    private globalModalService: ModalService,
  ) {}

  ngOnInit() {
    //#region restruct
    console.log("this.data: ", this.editMode);
    this.form.patchValue({ username: this.username });

    if (this.showLoginCaptcha()) {
      this.getLoginCaptcha();
    }

    if (this.thirdpartyType === PlatformType.MeiTuanJiuDian) {
      this.loopRequestMeituanLoginStatus();
    }

    //#endregion
  }

  ngAfterViewInit() {}

  showLoginCaptcha() {
    return [
      PlatformType.TuJia,
      PlatformType.MuNiao,
      PlatformType.Ctrip,
      PlatformType.Fliggy,
      PlatformType.MeiTuanJiuDian,
      PlatformType.Douyin,
    ].includes(this.thirdpartyType);
  }

  private initCaptchaBlock() {
    console.log("captchaInfo: ", this.captchaInfo);
    const e = ["".concat("FFFF0N000000000085D5"), new Date().getTime(), Math.random()].join(":");
    const o = {
      renderTo: "#aliCode-nc",
      appkey: "FFFF0N000000000085D5",
      scene: "nc_register_pc",
      token: e,
      customWidth: 364,
      trans: { key1: "code0", isMobile: true },
      elementID: ["usernameID"],
      is_Opt: 0,
      language: "cn",
      isEnabled: !0,
      timeout: 3e3,
      times: 5,
      apimap: {},
      ...this.captchaInfo,
      callback: (res) => {
        this.form.patchValue({ verifyPayload: res });
        // var n = { token: e, sessionId: o.csessionid, sig: o.sig };
        // t.$emit("setAliFlag", n);
      },
    };
    new noCaptcha(o);
  }

  //#region restruct

  private meituanLoginStatusOK() {
    return this.meituanLoginStatus === 1;
  }

  private loopRequestMeituanLoginStatus() {
    const Key = "meituan_login_info";
    interval(1000)
      .pipe(takeUntil(this.destroy$))
      .subscribe((res) => {
        const obj = this.storeService.get(Key, 2);

        if (!obj) {
          this.meituanLoginStatus = null;
        } else {
          const status = obj.status;
          this.meituanLoginStatus = +status;
          if (this.meituanLoginStatusOK()) {
            this.meituanLoginInfo = obj;
          }
        }
        console.log("meituanloginstatus: ", this.meituanLoginStatus);
      });
  }

  confirm() {
    if (this.editMode === EditMode.Create) {
      this.createAccountV2();
    } else if (
      this.thirdpartyType === PlatformType.MeiTuanJiuDian &&
      this.meituanLoginStatusOK() &&
      !this.form.value.password
    ) {
      /** 使用插件登录美团账号 */
      this.meituanDirectLogin();
      // if (!this.meituanLoginStatusOK()) {
      //   /** 没装插件，则需要联系客服 */
      //   this.meituanLoginContactTip();
      // } else if (!this.form.value.password) {
      //   /** 没填密码，则不需修改密码，直接登录 */
      //   this.meituanDirectLogin();
      // }
    } else {
      this.updateAccountV2();
    }
  }

  private createAccountV2() {
    const params = {
      username: this.form.value.username,
      password: this.form.value.password,
      thirdparty_type: this.thirdpartyType,
    };

    this.accountService.createAccount(params).subscribe((res) => {
      const accountId = _.get(res, "data.id");
      if (!accountId) {
        return;
      }

      const transferedData = {
        id: accountId,
        username: this.form.value.username,
      };

      // 飞猪展示一个 iframe
      if (this.thirdpartyType === PlatformType.Fliggy) {
        this.displayFliggyLoginIframe(accountId);
        return;
      }

      if (this.thirdpartyType === PlatformType.TuJia) {
        Object.assign(transferedData, {
          tujia: {
            verify_key: this.verifyKey,
            verify_code: this.form.value.verifyCode,
            verify_payload: this.form.value.verifyPayload,
          },
        });
      } else if (this.thirdpartyType === PlatformType.Ctrip || this.thirdpartyType === PlatformType.Douyin) {
        Object.assign(transferedData, {
          tujia: {
            verify_key: this.verifyKey,
            verify_code: this.form.value.verifyCode,
          },
        });
      } else if (
        this.thirdpartyType === PlatformType.MuNiao
        // this.thirdpartyType === PLATFORM_TYPE.FLIGGY
      ) {
        Object.assign(transferedData, {
          muniao: {
            verify_key: this.verifyKey,
            verify_code: this.form.value.verifyCode,
          },
        });
      } else if (this.thirdpartyType === PlatformType.MeiTuanJiuDian) {
        _.assign(transferedData, {
          meituan: {
            verify_key: this.verifyKey,
            verify_code: this.form.value.verifyCode,
            verify_payload: _.get(this.meituanLoginInfo, "secrets"),
          },
        });
      }

      // if (this.thirdpartyType === PLATFORM_TYPE.MEITUAN) {
      //   // this.storeService.set('meituan_delete_login_status', 1, 2);
      //   this.meituanLoginContactTip();
      // } else {
      this.accountService.displayLoginLoadingModal({
        data: transferedData,
        thirdpartyType: this.thirdpartyType,
      });
      // }

      this.subject.triggerOk();
      this.subject.destroy("onOk");

      // this.subject.destroy({
      //   type: 'login',
      //   data: transferedData
      // });
    });
  }

  private updateAccountV2() {
    const params = {
      id: this.accountId,
      new_password: this.form.value.password,
      old_password: null,
    };

    this.accountService.modifyPassword(params).subscribe((res) => {
      // 飞猪展示一个 iframe
      if (this.thirdpartyType === PlatformType.Fliggy) {
        this.displayFliggyLoginIframe();
        // this.modalService.create({
        //   nzTitle: null,
        //   nzContent: `<iframe src="/web/fliggy/qrcode/scan.html?thirdparty_account_id=${this.accountId}"></iframe>`
        // })
        return;
      }

      const transferedData = {
        id: this.accountId,
        username: this.username,
      };

      if (
        this.thirdpartyType === PlatformType.TuJia ||
        this.thirdpartyType === PlatformType.Ctrip ||
        this.thirdpartyType === PlatformType.Douyin
        // this.thirdpartyType === PlatformType.Fliggy
      ) {
        _.assign(transferedData, {
          tujia: {
            verify_key: this.verifyKey,
            verify_code: this.form.value.verifyCode,
            verify_payload: this.form.value.verifyPayload,
          },
        });
      } else if (this.thirdpartyType === PlatformType.MuNiao) {
        _.assign(transferedData, {
          muniao: {
            verify_key: this.verifyKey,
            verify_code: this.form.value.verifyCode,
          },
        });
      } else if (this.thirdpartyType === PlatformType.MeiTuanJiuDian) {
        _.assign(transferedData, {
          meituan: {
            verify_key: this.verifyKey,
            verify_code: this.form.value.verifyCode,
            verify_payload: _.get(this.meituanLoginInfo, "secrets"),
          },
        });
      }

      this.subject.destroy();
      this.accountService.displayLoginLoadingModal({
        data: transferedData,
        thirdpartyType: this.thirdpartyType,
      });

      // this.subject.destroy({
      //   type: 'login',
      //   data: transferedData
      // });
    });
  }

  private displayFliggyLoginIframe(id?) {
    this.fliggyIframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
      `/web/fliggy/qrcode/scan.html?thirdparty_account_id=${id ? id : this.accountId}`,
    );
    const modal = this.modalService.create({
      nzTitle: null,
      nzContent: this.fliggyIframe,
      nzFooter: null,
    });

    modal.afterClose.subscribe(() => {
      this.subject.triggerOk();
      this.subject.destroy("onOk");
    });
  }

  private meituanDirectLogin() {
    // const id = _.get(this.meituanLoginInfo, 'account.accountId');
    const id = this.accountId;
    const payload = _.get(this.meituanLoginInfo, "secrets");
    const params = {
      id,
      meituan: {
        verify_payload: payload,
      },
    };
    this.subject.destroy();
    this.accountService.displayLoginLoadingModal({
      data: params,
      thirdpartyType: this.thirdpartyType,
    });
  }

  private meituanLoginContactTip() {
    this.modalService.confirm({
      nzTitle: "请您联系客服完成后续操作",
      nzContent: "请您在工作日的10:30~19:00联系客服，由客服协助您完成账号登录。",
      nzOkText: "联系客服",
      nzOnOk: () => {
        this.globalModalService.displayCustomerServiceClient();
      },
    });
  }

  isBtnDisabled() {
    if (this.editMode === EditMode.Update) {
      // 重新登录可以不修改密码
      return false;
    }

    if (this.form.invalid) {
      return true;
    }

    if (
      [PlatformType.TuJia, PlatformType.MuNiao, PlatformType.Ctrip, PlatformType.Fliggy].includes(this.thirdpartyType)
    ) {
      return !this.form.value.verifyCode;
    }

    return false;
  }

  //#endregion

  getLoginCaptcha() {
    this.accountService.getLoginCaptcha({ thirdparty_type: this.thirdpartyType }).subscribe((res) => {
      if (res.error_code === 0) {
        this.verifyImage = this.sanitizer.bypassSecurityTrustUrl("data:img/jpg;base64," + res.data?.content_base64);
        this.verifyKey = res.data.verify_key;

        this.captchaInfo = res.data.captcha_info;

        if ([PlatformType.TuJia].includes(this.thirdpartyType)) {
          this.initCaptchaBlock();
        }
        // if (this.thirdpartyType === PLATFORM_TYPE.FLIGGY) {
        //   this.captchaInfo.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(`/web/tb/captcha?x5secdata=${this.captchaInfo.x5secdata}`)
        // }
      }
    });
  }

  cancel() {
    this.subject.destroy("onCancel");
  }

  forgetPasswordInfo() {
    const thirdparty = this.translate.syncGet("word.channel_" + this.thirdpartyType);
    this.modalService.info({
      // 若忘记密码，请前往{{ thirdparty }}app或网站找回密码，核实无误后再返回此页面绑定。
      nzTitle: this.translate.syncGet("warning.channel_forget_password", {
        thirdparty: thirdparty,
      }),
      nzContent: null,
      // 知道了
      nzOkText: this.translate.syncGet("word.got_it"),
    });
  }

  ngOnDestroy() {
    this.destroy$.next(null);
    this.destroy$.complete();
  }
}
